<template>
    <v-app>
      <v-layout column fill-height @click.stop="" ref="app_wrapper" pa-0 ma-0 style="position: relative" >
        <v-layout column v-show="!eventsJournalFillHeight" fill-height pa-0 ma-0 style="position: relative" :style="toolbarOpen ? 'height: 50%' : 'height: 100%'">
          <v-layout class="primary" justify-space-between align-center style="height: 44px" px-0 py-0 ma-0>

            <v-layout column fill-height class="primary"  style="height: 44px" >
              <v-flex px-2 pt-0>
                <svg-icon
                  :color="'white'"
                  :name="'logo'"
                  width="210"
                />
              </v-flex>
            </v-layout>

            <v-flex xs1>

            </v-flex>

            <v-flex xs10 pl-4>
              <v-layout justify-space-between align-center pl-2>
                <span class="accent--text text-uppercase font-weight-bold caption">{{ $t($router.currentRoute.meta.toolbar) }}</span>
                <v-icon v-if="$router.currentRoute.meta.toolbar"  :size="24" color="white">chevron_right</v-icon>
                <crumbs v-if="$router.currentRoute.meta.toolbar"  :crumbs="crumbs" background="primary"/>
              </v-layout>
            </v-flex>

            <!-- Панель с кнопками "добавить", "Изменить", "Избранное" -->
            <v-layout class="primary" fill-height justify-space-around align-center px-2>

              <v-tooltip bottom color="secondary">
                <v-btn :data-testid="$options.name + 'v-btn' + 'rosatom'" icon flat v-if="$store.state.auth.user.level <= 1" @click="" 
                    dark medium class="lighten-2 font-weight-medium" slot="activator" >
                  <svg-icon
                    :color="'white'"
                    :name="'rosatom'"
                    width="28"
                  />
                </v-btn>
                <span>{{ $t('rosatom') }}</span>
              </v-tooltip>

              </v-layout>

          </v-layout>

          <v-layout ref="app" fill-height pa-0 ma-0 style="position: relative">
              <left-bar
                v-if="!kiosk"
                @topology=""
                @loadTree="() => {$store.dispatch('loadTree')}"
                @createRootElement="() => createRootElement()"
                :leftBarMini="leftBarMini"
                :sidebarWidth="leftBarWidth"
                ref="left-bar"
              />
            <v-layout @click.stop="" column fill-height ref="bar_wrapper" :style="`width: ${bar_width}px; height: 100%; position: relative;`" pa-0 ma-0>

              <v-btn small absolute left center class="drawer_button" style="height: 20px; width: 20px" icon dark
                v-if="leftBarMini" 
                :data-testid="$options.name + '__btn__' + '!leftBarMini'"
                @click.stop="() => barMini()">
                  <v-icon small color="lightgrey">navigate_next</v-icon>
              </v-btn>
              <v-btn small absolute left center class="drawer_button" style="height: 20px; width: 20px" icon dark
                v-if="!leftBarMini" 
                :data-testid="$options.name + '__btn__' + 'leftBarMini'"
                @click.stop="() => barMini()" >
                  <v-icon small color="lightgrey">navigate_before</v-icon>
              </v-btn>
              
              <div style="position: relative; height: 100%; width: 100%">

                <loader
                  :show="loader"
                  :zindex="100"
                />

                <create-location-bar
                  :open="getLocationBarCreate"
                  :data="getRootElement"
                  @update="() => onTreeUpdate()"
                  @close="() => onLocationCreateClose()"
                />
                <keep-alive>
                  <router-view v-if="$route.meta.keepAlive" :key="$route.path"/>
                </keep-alive>

                <router-view v-if="!$route.meta.keepAlive"/>

              </div>

            </v-layout>

            <vue-snotify/>
          </v-layout>

        </v-layout>

        <v-layout shrink v-if="!kiosk" class="white" style="" align-center>
          
          <v-toolbar 
            dense
            class="white" 
            prominent
            :height="toolbarHeight"
            @click.stop=""
          >

          <v-toolbar-items>
            <v-layout column align-start justify-start ma-0>
              <v-layout align-center>
                <v-layout column shrink align-start justify-space-between ma-0>
                  
                  <v-btn flat x-small style="margin-top: 14px" dark class="white" slot="activator"
                    v-if="toolbarOpen && !eventsJournalFillHeight" 
                    :data-testid="$options.name + '__btn__' + 'toolbar_open_max'"
                    @click.stop="eventsJournalFillHeight = !eventsJournalFillHeight" >
                      <v-icon color="blacktext">expand_less</v-icon>
                  </v-btn>

                  <v-btn flat x-small style="margin-top: 14px" dark class="white" slot="activator"
                    v-if="eventsJournalFillHeight" 
                    :data-testid="$options.name + '__btn__' + 'toolbar_close_max'"
                    @click.stop="eventsJournalFillHeight = !eventsJournalFillHeight" >
                      <v-icon color="blacktext">expand_more</v-icon>
                  </v-btn>

                  <v-btn flat x-small dark class="white" slot="activator" style="margin-top: 14px"
                    v-if="!toolbarOpen" 
                    :data-testid="$options.name + '__btn__' + 'toolbar_open'"
                    @click.stop="toolbarClickHandler" >
                      <v-icon color="blacktext">expand_less</v-icon>
                  </v-btn>

                  <v-btn flat x-small dark class="white" slot="activator"
                    v-if="toolbarOpen && !eventsJournalFillHeight" 
                    :data-testid="$options.name + '__btn__' + 'toolbar_close'"
                    @click.stop="(e) => toolbarClickHandler(e, true)" >
                      <v-icon color="blacktext">expand_more</v-icon>
                  </v-btn>

                </v-layout>

                <v-flex shrink py-2>

                  <v-tabs
                    color="white" light
                    style="width: 100%; height: 40px"
                    :data-testid="$options.name + '__tabs__' + 'toolbar'"
                    v-model="current.journalTab"
                  >
                    <v-tabs-slider color="transparent" style="height: 0px; max-width: 0px"></v-tabs-slider>
                    <v-tab
                      class="font-weight-normal bltabs"
                      v-for="(page, index) in getTabs"
                      :key="index"
                      :data-testid="$options.name + '__' + page + '_tab__' + 'toolbar'"
                      @click.stop="toolbarClickHandler"
                    > 
                      <template slot="default">
                        <div :class="getTabs[current.journalTab] == page ? 'custom-tab-button active' : 'custom-tab-button'"
                          :data-testid="$options.name + '__' + page + '_tab_template__' + 'toolbar'"
                        >
                          {{ $t(page) }} 
                        </div>
                      </template>

                    </v-tab>
                  </v-tabs>

                </v-flex>

            </v-layout>
            </v-layout>
          </v-toolbar-items>
          <v-spacer/>

          <v-toolbar-items>
            <v-layout column align-start justify-start ma-0>
              <v-flex shrink>
                <v-layout shrink style="align-items: center" pt-2>
                  <v-layout shrink>
                    <statuses
                      @status="(payload) => onStatus(payload)"
                    />
                  </v-layout>
                  
                  <v-menu
                    v-model="user.menu"
                    :data-testid="$options.name + '__menu__' + 'user.menu'"
                    :close-on-content-click="false"
                    :nudge-width="100"
                    offset-y
                    top
                  >
                    <template v-slot:activator="{ on }">
                        <v-btn flat icon medium  v-on="on" 
                        :data-testid="$options.name + '__btn__' + 'user'"
                        @click.stop="">
                          <svg-icon
                            :color="'grey'"
                            :name="'admin'"
                            width="28"
                          />
                        </v-btn>
                    </template>

                    <v-card style="width: 250px; border: solid 1px grey; border-radius: 8px"
                      :data-testid="$options.name + '__card__' + 'user'"
                    >
                      <v-card-text>
                        <v-layout column fill-height>

                          <v-flex shrink px-2>
                            <v-layout fill-height justify-space-between>
                              <span>{{$t('login')}}:</span>
                              <v-flex shrink pl-2>
                                <span style="word-break: break-word">{{getUser.login}}</span>
                              </v-flex>
                            </v-layout>
                          </v-flex>

                          <v-flex shrink px-2>
                            <v-layout fill-height justify-space-between>
                              <span>{{$t('role')}}:</span>
                              <span>{{$t(getUser.role)}}</span>
                            </v-layout>
                          </v-flex>

                          <v-flex shrink px-2>
                            <v-layout fill-height justify-space-between>
                              <span>{{$t('entrance time')}}:</span>
                              <span>{{$moment(getUser.startRT).format('HH:mm')}}</span>
                            </v-layout>
                          </v-flex>

                          <v-flex shrink px-2>
                            <v-layout fill-height justify-space-between>
                              <span>{{$t('session time')}}:</span>
                              <span>{{currentTime}}</span>
                            </v-layout>
                          </v-flex>

                          <v-btn dark small outline color="secondary"
                            :data-testid="$options.name + '__btn__' + 'user.menu__logout'"
                            @click="logout" >
                              {{$t('log out')}}
                          </v-btn>
                          <v-btn dark small outline color="secondary"
                            :data-testid="$options.name + '__btn__' + 'user.menu__change_password'"
                            @click="dialog.changePass.show = !dialog.changePass.show" >
                              {{$t('change password')}}
                          </v-btn>
                          <v-btn dark small outline color="secondary"
                            :data-testid="$options.name + '__btn__' + 'user.menu__close'"
                            @click="user.menu = !user.menu" >
                              {{$t('close')}}
                          </v-btn>

                        </v-layout>
                      </v-card-text>
                    </v-card>

                  </v-menu>
                  
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-toolbar-items>
          </v-toolbar>
        
        </v-layout>

        <v-layout v-show="toolbarOpen "ref="eventsJournal" :style="getJournalHeight">
          <keep-alive>
            <div class="journal-wrapper-iframe" :style="`position: relative; width: ${getTabs[current.journalTab] == 'states' ? '100%' : '0%'}`">
              <iframe
                ref="iframeJournal" 
                :data-testid="$options.name + '__iframe__' + 'iframeJournal'"
                :key="getAuthKey"
                :objectId="getJournalObjectId"
                :src="getIframeSrc"
                :passive="getTabs[current.journalTab] != 'states'"
                class="journal-wrapper-iframe"
                seamless="seamless"
                allowfullscreen
                >
              </iframe>
            </div>
            
          </keep-alive>

          <tasks-journal
            v-show="getTabs[current.journalTab] == 'actions'"
            :show="getTabs[current.journalTab] == 'actions'"
          />
          <syslog-journal
            v-show="getTabs[current.journalTab] == 'events'"
            :show="getTabs[current.journalTab] == 'events'"
          />
          <service-journal
            v-show="getTabs[current.journalTab] == 'service'"
            :show="getTabs[current.journalTab] == 'service'"
          />
          <system-journal
            v-show="getTabs[current.journalTab] == 'system journal'"
            :show="getTabs[current.journalTab] == 'system journal'"
          />
          <audit-journal
            v-show="getTabs[current.journalTab] == 'audit'"
            :show="getTabs[current.journalTab] == 'audit'"
          />
        </v-layout>
        
        <loader
          :show="!$store.state.monitoring.serverConnect"
        />

        <loader
          :show="isEdit"
          :circle="false"
          :cursor="'no-drop'"
        />
        
        <dialog-drag
          v-for="(item, index) in Object.keys(getDialogs)"
          :key="'dialog_' + index"
          v-if="getDialogs[item].show"
          :title="getDialogs[item].data.title"
          :id="'dialog_' + index"
          :options="getDialogs[item].data.options || {
            width: $el.clientWidth * 0.6,
            height: $el.clientHeight * 0.4,
            top: 100
          }"
          :data-testid="$options.name + '__dialog-drag__' + 'dialog_' + index"
          @close="(payload) => {closeDialog(payload, getDialogs[item])}"
          ref="dialog-drag"
          >
            <modal
              :data="getDialogs[item].data"
              :data-testid="$options.name + '__dialog-drag__' + 'modal_' + index"
              @close="(payload) => {closeDialog(payload, getDialogs[item])}"
            />

        </dialog-drag>

        <v-dialog persistent max-width="50%" 
          v-model="dialog.changePass.show" 
          v-if="dialog.changePass.show"
          :data-testid="$options.name + '__dialog-changePass'">
          <change-pass-card
            @close="() => {dialog.changePass.show = !dialog.changePass.show}"
          />
        </v-dialog>

      </v-layout>
    </v-app>
</template>

<script lang="ts">
import Vue from 'vue'
import loader from '@/nms/components/partials/loader.vue'
import leftBar from '@/nms/layouts/left_bar'
import CreateLocationBar from '@/nms/pages/location/create-location-bar.vue'
import Crumbs from '@/nms/components/partials/bread-crumbs.vue'
import statuses from '@/nms/components/partials/statuses.vue'
import svgIcon from '@/nms/components/media/svg/static/svg-icon.vue'
import DialogDrag from '@/nms/plugins/vue-dialog-drag/src/components/vue-dialog-drag.vue'
import ChangePassCard from '@/nms/pages/auth/change-pass-card.vue'
import modal from '@/nms/components/modal/modal.vue'
import syslogJournal from '@/nms/pages/events/events-journal-syslog.vue'
import serviceJournal from '@/nms/pages/events/events-journal-service.vue'
import systemJournal from '@/nms/pages/journal/system-journal.vue'
import auditJournal from '@/nms/pages/journal/auditJournal.vue'
import tasksJournal from '@/nms/pages/journal/tasks-journal.vue'
import { getSubscription } from '@/nms/components/utils/push-notifications/SWRegister'
import { connect } from 'mqtt'
import { mapGetters } from 'vuex'

// Типы
interface BarState {
  location: {
    rootElement: any | null
    create: { open: boolean }
  }
}

interface DialogState {
  changePass: { show: boolean }
}

interface CurrentState {
  tab: number
  journalTab: number
}

interface UserData {
  access_token?: string
  login?: string
  role?: string
  push_active?: string
  startRT?: string
  [key: string]: any
}

interface AuthState {
  user: UserData | null
  loader: Record<string, boolean>
}

interface RootState {
  auth: AuthState
  devices: {
    treeActive: any[]
  }
  structure: {
    current: {
      tab: string
      module: string
    }
  }
  monitoring: {
    serverConnect: boolean
  }
}

interface WebuiVersion {
  name?: string
  imageTag?: string
  [key: string]: any
}

export default Vue.extend({
  name: 'BASELINE',

  components: {
    loader,
    leftBar,
    CreateLocationBar,
    Crumbs,
    statuses,
    svgIcon,
    ChangePassCard,
    modal,
    DialogDrag,
    syslogJournal,
    serviceJournal,
    systemJournal,
    auditJournal,
    tasksJournal,
  },

  props: {},

  data(): {
    bar_width: number
    leftBarMini: boolean
    leftBarWidth: number
    toolbarOpen: boolean
    toolbarHeight: number
    showEventsJournal: boolean
    eventsJournalFillHeight: boolean
    isJournalFullscreen: boolean
    crumbs: any[]
    bar: BarState
    dialog: DialogState
    editMode: boolean
    version: string | null
    loader: boolean
    user: { menu: boolean }
    current: CurrentState
    currentTime: number
    timer: number | null
  } {
    return {
      bar_width: 0,
      leftBarMini: false,
      leftBarWidth: 400,
      toolbarOpen: false,
      toolbarHeight: 64,
      showEventsJournal: false,
      eventsJournalFillHeight: false,
      isJournalFullscreen: false,
      crumbs: [],
      bar: {
        location: {
          rootElement: null,
          create: { open: false },
        },
      },
      dialog: {
        changePass: { show: false },
      },
      editMode: false,
      version: null,
      loader: false,
      user: { menu: false },
      current: { tab: 0, journalTab: 0 },
      currentTime: 0,
      timer: null,
    }
  },

  computed: {
    isEdit(): boolean {
      return this.$store.getters.getEditMode
    },

    getData(): any {
      // const state = this.$store.state as unknown as RootState
      // return state.devices.treeActive[0]
      return this.$store.getters.getTreeActive
    },

    getTabs(): string[] {
      const pages = this.$store.getters.getBaselineNails.journal.pages
      const state = this.$store.state as unknown as RootState
      const level = state.auth.user?.level

      if (level !== 0 && level !== 3) {
        return pages.filter(page => page !== 'audit')
      }
      return pages
    },

    getPages(): string[] {
      const pages$ = this.$store.getters.getPages as string[]
      console.log(this.$options.name, 'getPages', pages$)
      const state = this.$store.state as unknown as RootState
      const level = state.auth.user?.level

      if (level === 1 || level === 2) {
        return pages$.filter(page => page !== 'audit' && page !== 'users')
      } else if (level !== 0) {
        return pages$.filter(page => page !== 'users')
      }
      return pages$
    },

    getLocationBarCreate(): boolean {
      return this.bar.location.create.open
    },

    getRootElement(): any | null {
      return this.bar.location.rootElement
    },

    getUser(): UserData | null {
      const state = this.$store.state as unknown as RootState
      return state.auth.user
    },

    getJournalObjectId(): null {
      return null
    },

    getAuthKey(): string | null {
      return this.getUser?.access_token || null
    },

    getJournalHeight(): string {
      if (!this.showEventsJournal) {
        return 'height: 0%'
      } else if (this.eventsJournalFillHeight) {
        return 'height: 100%'
      } else {
        return 'height: 40%'
      }
    },

    getIframeSrc(): string {
      const baseParams = (this as any).$localhost
        ? '&kiosk=true&route=/app/dutyJournal&initApp=false'
        : '&kiosk=true&route=/app/dutyJournal'
      return `/e-ui?key=${this.getUser?.access_token}${baseParams}`
    },

    ...mapGetters(['getDialogs', 'kiosk']),
  },

  watch: {
    '$store.state.auth.loader': {
      handler(newVal: Record<string, boolean>): void {
        if (Object.keys(newVal).length) {
          let loader$ = false
          Object.keys(newVal).forEach(key => {
            if (newVal[key]) {
              loader$ = true
              return
            }
          })
          this.loader = loader$
        } else {
          this.loader = false
        }
      },
      deep: true
    },

    '$store.state.monitoring.serverConnect': {
      handler(newVal: boolean): void {
        if (!newVal) {
          const message = this.$getTranslate('server connection lost')
          alert(message)
        }
      },
      deep: true
    },

    '$store.state.structure.current.tab': {
      handler(newVal: string): void {
        const pages = this.getPages
        if (newVal !== pages[this.current.tab]) {
          pages.forEach((item, i) => {
            if (item === newVal) {
              this.current.tab = i
            }
          })
        }
      }
    },

    getData: {
      async handler(newVal: any): Promise<void> {
        console.log('WATCH', this.$options.name, 'getData', newVal)
        // if (newVal) {
          this.crumbs = await this.$createCrumbs(newVal)
        // }
      },
      deep: true
    },

    toolbarOpen: {
      handler(newVal: boolean): void {
        if (newVal) {
          this.showEventsJournal = true
        } else {
          this.showEventsJournal = false
        }
      },
      deep: true
    },
  },

  created(): void {
    this.setup()
    this.serverPingSubscribe()
    this.testMethod()
  },

  mounted(): void {
    window.addEventListener('beforeunload', this.handleBeforeUnload)
    window.addEventListener('unload', this.handleUnload)
    window.addEventListener('resize', this.handleWindowResize)
    this.handleWindowResize()

    this.startTimer()
    document.addEventListener('mouseup', this.stopResizeBlock)
    document.addEventListener('keyup', this.closeModalOnESC)
    this.createSubscription()
  },

  beforeDestroy(): void {
    window.removeEventListener('beforeunload', this.handleBeforeUnload)
    window.removeEventListener('unload', this.handleUnload)
    window.removeEventListener('resize', this.handleWindowResize)
    document.removeEventListener('keyup', this.closeModalOnESC)
    this.stopTimer()
  },

  methods: {
    async testMethod(): Promise<void> {
      try {
        // Метод предназначен для переопределения при необходимости

        //device$352
        // const obj$ = await this.$bridge.getObjectById('device$352')
        // const obj$ = await this.$bridge.getObjectById('device$352')
        // let m = await obj$.meta()
        // const refs$ = await obj$.getRefs()
        // const measures = await obj$.getMeasures(true, false)
        // if (measures) {
        //   console.log('TEST_MEASURES', measures)
        // }
        // let cook = document.cookie
        // console.log('cook', cook)


      } catch (err) {
        console.error(err)
      }
    },

    barMini(): void {
      this.leftBarMini = !this.leftBarMini
    },

    handleBeforeUnload(event: BeforeUnloadEvent): void {
      this.$store.dispatch('clearDabLock')
      event.preventDefault()
      event.returnValue = ''
    },

    handleUnload(): void {
      // this.logout()
    },

    async createRootElement(): Promise<void> {
      const root = await this.$bridge.getByPath('/physical')
      this.$set(this.bar.location, 'rootElement', root)
      this.$set(this.bar.location.create, 'open', !this.bar.location.create.open)
      this.$store.dispatch('setEditMode', true)
    },

    async onTreeUpdate(): Promise<void> {
      await this.$store.dispatch('loadTree')
      this.$set(this.bar.location, 'rootElement', null)
      this.$set(this.bar.location.create, 'open', false)
      this.$store.dispatch('setEditMode', false)
    },

    onLocationCreateClose(): void {
      this.$set(this.bar.location, 'rootElement', null)
      this.$set(this.bar.location.create, 'open', false)
      this.$store.dispatch('setEditMode', false)
    },

    async createSubscription(): Promise<void> {
      const subscription = getSubscription()
      const curUser = this.$store.getters.getCurrentUser as UserData | null
      const pushActive = curUser?.push_active === 'true'

      if (subscription && curUser?.login) {
        await this.$bridge.customQuery('core', 'notification/subscribe', {
          push_active: pushActive,
          name: curUser.login,
          cls: curUser.role,
          subscription: subscription
        }, 'post')
      } else {
        console.log('Push error: "Refresh page"')
      }
    },

    async setup(): Promise<void> {
      this.loadServerMeasures()

      await this.$store.dispatch('closeDialog')
      if (!this.kiosk) {
        await this.$store.dispatch('loadTree')
        await this.$store.dispatch('loadStatistics')
        await this.$store.dispatch('loadBooks')
        this.$store.dispatch('checkMapSource')
      }
      await this.$store.dispatch('saveUserProps')
      this.$store.dispatch('mqttConnect')

      this.getApplicationVersion()
      await this.checkLogged()
      this.$nextTick(() => {
        this.$store.commit('SET_INTERFACE_LOADED', true)
      })
    },

    async checkLogged(): Promise<void> {
      this.$bridge.on('unauthorized', () => {
        console.log(this.$options.name, 'CHECK_LOGGED unauthorized')
        this.$store.dispatch('setLoader')
        this.unsubscribeAll()
        this.$router.push({ name: 'login' })
      })
    },

    async unsubscribeAll(): Promise<void> {
      await this.$store.dispatch('unsubscribeAll')
    },

    startTimer(): void {
      const startRT = this.getUser?.startRT
      if (startRT) {
        const d = (this as any).$moment().diff(startRT)
        this.currentTime = (this as any).$moment(d).utc().format('HH:mm')
        this.timer = window.setInterval(() => {
          const diff = (this as any).$moment().diff(this.getUser?.startRT)
          this.currentTime = (this as any).$moment(diff).utc().format('HH:mm')
        }, 30000)
      }
    },

    stopTimer(): void {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },

    closeDialog(payload?: any, val?: any): void {
      this.$store.dispatch('closeDialog', val)
    },

    async logout(): Promise<void> {
      console.log(this.$options.name, 'logout')
      this.$store.dispatch('setLogged', false)
      await this.$bridge.logout()
      this.$router.push({ name: 'login' })
    },

    async serverPingSubscribe(): Promise<void> {
      await this.$store.dispatch('serverPingSubscribe')
    },

    async loadServerMeasures(): Promise<void> {
      const obj = await this.$bridge.getByPath('/config/server')
      const measures = await obj.getMeasures(true)
      if (measures) {
        this.licenseSubscribe('serverMeasures', measures, 'serverMeasures')
      }
    },

    onStatus(val: any): void {
      console.log(this.$options.name, 'onStatus', val)
    },

    setDialog(val: any): void {
      console.log(this.$options.name, 'setDialog', val)
      const dialogData = {
        component: 'adminSettingsModal',
        id: 'adminSettingsModal',
        data: { val },
        title: this.$getTranslate('settings'),
        options: {
          width: (this.$el as HTMLElement).clientWidth * 0.8,
          height: (this.$el as HTMLElement).clientHeight * 0.7,
          top: 100
        }
      }
      this.$store.dispatch('setDialog', dialogData)
    },

    async licenseSubscribe(group: string, arr: any[], listener: string): Promise<void> {
      this.$store.dispatch('measuresSubscribeInit', {
        handler: this.subscribeHandler,
        group: group,
        listener: listener
      })
      await this.$bridge.subscribe(arr.map(obj => obj.$id))
    },

    subscribeHandler(e: { measure_id?: string; [key: string]: any }): void {
      if (e.measure_id === 'cmdb_counter_device') {
        console.log(this.$options.name, 'subscribeHandler', 'MEASURES', e)
        this.$store.dispatch('setServerMeasure', e)
      }
    },

    licenseUnsubscribe(group: string, listener: string): void {
      this.$store.dispatch('measuresSubscribeClose', {
        handler: this.subscribeHandler,
        group: group,
        listener: 'license'
      })
    },

    async getApplicationVersion(): Promise<void> {
      try {
        const d = await this.$bridge.customQuery('scripter', 'exec', { method: 'cluster.getContainersStatus' }, 'post') as WebuiVersion[]
        if (d) {
          const arr = Object.entries(d)
          const webui = arr.find(([key, value]) => value.name === 'webui')
          if (webui) {
            this.version = webui[1].imageTag
          }
        }
      } catch (err) {
        console.error('CATCH', this.$options.name, 'getApplicationVersion', err)
      }
    },

    setLoader(name: string, status: boolean): void {
      this.$store.dispatch('setLoader', {
        key: name,
        value: status
      })
    },

    closeModalOnESC(e: KeyboardEvent): void {
      if (e.which === 27 || e.keyCode === 27) {
        this.$store.dispatch('closeDialog')
      }
    },

    handleWindowResize(): void {
      if (this.$refs['bar_wrapper']) {
        this.bar_width = (this.$refs['bar_wrapper'] as HTMLElement).clientWidth
        this.leftBarWidth = Math.floor((this.$refs['app_wrapper'] as HTMLElement).clientWidth / 6)
      }
    },

    toolbarClickHandler(e: Event, val?: boolean): void {
      if (val) {
        this.toolbarOpen = false
        return
      }
      if (this.toolbarOpen) return
      this.toolbarOpen = true
    },

    resizeBlock(payload: MouseEvent): void {
      const app = this.$refs['app'] as HTMLElement
      const el = this.$refs['sidebar_wrapper'] as HTMLElement
      const view = this.$refs['bar_wrapper'] as HTMLElement

      if (el && view && app) {
        el.style.width = `${payload.clientX - 3}px`
        el.style.left = '0px'

        view.style.width = `${app.clientWidth - payload.clientX - 3}px`
        view.style.left = `${payload.clientX + 3}px`
      }
    },

    stopResizeBlock(): void {
      const el = this.$refs['sidebar_wrapper'] as HTMLElement
      const view = this.$refs['bar_wrapper'] as HTMLElement

      if (el) {
        el.style.position = 'relative'
        el.style.left = '0px'
      }
      if (view) {
        view.style.position = 'relative'
        view.style.left = '0px'
      }
      document.removeEventListener('mousemove', this.resizeBlock as any)
    },

    toggleFullscreen(): void {
      this.isJournalFullscreen = !this.isJournalFullscreen
      const iframe = this.$el.querySelector('.journal-wrapper-iframe') as HTMLElement
      if (this.isJournalFullscreen && iframe) {
        iframe.requestFullscreen()
      } else {
        document.exitFullscreen()
      }
    },
  },
})
</script>

<style lang="stylus">

  .active-menu
    color: red

  .tab-active
    border-bottom: solid 2px #F7941D

  .spacer
    width: 6px
    cursor: w-resize

  .toolbar__title_layout_baseline
    margin-left: 0

  .btn-icon_inactive
    &:hover,
    &:focus
      .btn__content
        &:before
          background-color: transparent

</style>

<style>

  .sidebar-blocked {
    background-color: red;
    z-index: 999;
  }

  .tabs {
    border: solid 1px #dbd8d8;
    border-radius: 4px;
  }

  .v-tabs__item:has(div.custom-tab-button) {
    padding: 0px 2px !important;
    border-bottom: solid 0px #ffffff !important;
  }

  .v-tabs__item {
    padding: 4px 2px !important;
    border-bottom: solid 1px #9F9F9F !important;
  }

  .tabs__border {
    border-bottom: solid 1px #9F9F9F !important;
  }

  .tab_wrapper { 
    background-color: #D4EEFC !important;
    height: 40px;
    border-left: solid 1px #9F9F9F !important;
    border-right: solid 1px #9F9F9F !important;
    border-top: solid 1px #9F9F9F !important;
    border-bottom: solid 1px #FFFFFF !important;
    border-radius: 2px;
    cursor: pointer;
  }

  .tab__border {
      background-color: #ffffff !important;
      font-size: 14px !important;
      height: 40px;
      border-bottom: solid 1px #FFFFFF !important;
      border-radius: 2px;
      padding: 2px 12px 12px 12px;
      margin-top: 10px;
      cursor: pointer;
  }

  .custom-tab {
    background-color: #ffffff !important;
    font-size: 14px !important;
    height: 39px;
    border-bottom: solid 1px #9F9F9F !important;
    border-radius: 2px;
    padding: 12px 12px 12px 12px;
    cursor: pointer;
  }

  .custom-tab-button {
    font-size: 14px !important;
    height: 40px;
    border-left: solid 1px #9F9F9F !important;
    border-right: solid 1px #9F9F9F !important;
    border-top: solid 1px #9F9F9F !important;
    border-bottom: solid 1px #9F9F9F !important;
    border-radius: 2px;
    padding: 11px 12px 12px 12px;
    cursor: pointer;
  }

  .journal-wrapper-iframe {
    border: 0;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: block;
  }
  
  .micro-menu {
    position: absolute;
    top: 10px;
    left: 10px;
    z-index: 10;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 4px;
    padding: 4px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  }
  
  .fullscreen-btn {
    background: white !important;
  }
  
  .fullscreen-btn:hover {
    background: #f5f5f5 !important;
  }

  .drawer_button {
    background-color: #ffffff;
    top: 50% !important;
    left: -12px !important;
    z-index: 5 !important;
    position: absolute !important;
    box-shadow: 0 4px 4px #00000066 !important;
  }

  .journal_tab_button {
    width: 100px;
    height: 40px;
  }


</style>
